export class RawFilterData {
	period: string | null;
	from?: string | null;
	to?: string | null;
	paymentMethodId: string | null;
	transactionStatusId: string | null;
	pageNumber: number;
}
